export default __webpack_public_path__ + "static/Donate_Food-32ea236859b5c8744013a11eaa324726.png";